import { Box } from '@chakra-ui/layout'
import { connectNetwork } from 'lib/NetworkProvider'
import moment from 'moment-timezone'
import 'moment/locale/it'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Input, Modal, Table } from 'semantic-ui-react'
import PackageEditor from '../job/PackageEditor'
import { baseViewDispatch, initializePage } from '../lib/util'
import Package from './Package'
function Packages(props) {
    const { searchText, network, table, time, label, field, format, toolbarResult, filtersResult, sortsResult, deletePackage, sub, login } = props
    const [showNoteEditor, setShowNoteEditor] = useState({
        show: false,
        pack: null,
    })

    const [packs, setPackages] = useState([])
    const [count, setCount] = useState(0)
    const [dirty, setDirty] = useState(false)
    const [creating, setCreating] = useState(false)
    const [editing, setEditing] = useState(false)
    const [filters, setFilters] = useState({})
    const [sorts, setSorts] = useState({})
    const [page, setPage] = useState(0)
    const pageRef = useRef()
    const countRef = useRef()

    const items = 10

    pageRef.current = page
    countRef.current = count

    useEffect(() => {
        network.getPackageList(searchText ? searchText : '', false, filters, sorts, page, 10).then((data) => {
            // console.log(data)

            const packs = []
            for (const key in data.data) {
                packs.push(data.data[key])
            }
            setCount(data.count)
            setPackages(packs)
            setDirty(false)
        })
    }, [dirty, deletePackage.fetching, page, searchText])

    useEffect(() => {
        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        let extraTools = []
        if (user && !!user.manage_article) {
            extraTools.push({
                name: 'Crea nuovo Imballo',
                icon: 'add',
                action: () => {
                    setCreating(true)
                },
            })
            // extraTools.push({
            //     name: 'Importa stampi da file',
            //     icon: 'check',
            //     action: () => {
            //         this.setState({
            //             showImport: true,
            //         })
            //     },
            // })
        }

        const toolbar = sub
            ? []
            : [
                  ...extraTools,
                  {
                      name: '',
                      icon: 'arrow left',
                      position: 'right',
                      action: function () {
                          if (pageRef.current > 0) {
                              setPage(pageRef.current - 1)
                          }
                      },
                  },
                  {
                      name: '',
                      icon: 'arrow right',
                      position: 'none',
                      action: function () {
                          if (pageRef.current * 10 + 10 < countRef.current) {
                              setPage(pageRef.current + 1)
                          }
                      },
                  },
              ]

        const sortoptions = {
            packCode: {
                name: 'packCode',
                label: 'Codice Imballo',
                onChange: (obj, value) => {
                    sorts[obj.name] = value
                    setSorts(sorts)
                    setPackages([])
                    setDirty(true)
                },
                onReset: (obj) => {
                    delete sorts[obj.name]
                    setSorts(sorts)
                    setPackages([])
                    setDirty(true)
                },
            },
            creationDate: {
                name: 'creationDate',
                label: 'Data di creazione',
                onChange: (obj, value) => {
                    sorts[obj.name] = value
                    setSorts(sorts)
                    setPackages([])
                    setDirty(true)
                },
                onReset: (obj) => {
                    delete sorts[obj.name]
                    setSorts(sorts)
                    setPackages([])
                    setDirty(true)
                },
            },
        }

        const filteroptions = {
            packCode: {
                control: Input,
                name: 'packCode',
                input: 'text',
                placeholder: 'Codice Imballo',
                label: 'Codice Imballo',
                onChange: (e) => {
                    filters.packCode = { value: e.target.value, key: 'packCode', operator: '=' }
                    setFilters(filters)
                    setDirty(true)
                },
                onReset: () => {
                    setFilters(filters)
                    setPackages([])
                    setDirty(true)
                },
            },
            packName: {
                control: Input,
                name: 'packName',
                input: 'text',
                placeholder: 'Nome Imballo',
                label: 'Nome Imballo',
                onChange: (e) => {
                    filters.packName = { value: e.target.value, key: 'packName', operator: '=' }
                    setFilters(filters)
                    setDirty(true)
                },
                onReset: () => {
                    setFilters(filters)
                    setPackages([])
                    setDirty(true)
                },
            },
        }

        initializePage({ props: { toolbarResult, filtersResult, sortsResult } }, toolbar, filteroptions, sortoptions)
    }, [])

    return (
        <>
            <Box ml={16} mt={4}>
                Visualizzando {page * items} - {page * items + items} su {count}
            </Box>
            {packs && packs.length && (
                <Table celled sortable>
                    <Package
                        type="header"
                        sorts={sorts}
                        onPackageCodeHeaderClick={() => {
                            if (!sorts.packCode) {
                                sorts.packCode = 'asc'
                            } else if (sorts.packCode === 'asc') {
                                sorts.packCode = 'desc'
                            } else {
                                delete sorts.packCode
                            }
                            setSorts(sorts)
                            setPackages([])
                            setDirty(true)
                        }}
                    />
                    <Table.Body>
                        {packs.map((value, index) => {
                            return (
                                <Package
                                    key={value.packageId}
                                    type="table"
                                    pack={value}
                                    onRowClick={(state) => {
                                        const { packageId } = state
                                        setEditing(packageId)
                                        setDirty(true)
                                    }}
                                />
                            )
                        })}
                    </Table.Body>
                </Table>
            )}

            <Modal
                closeIcon
                open={!!editing || !!creating}
                onClose={() => {
                    setEditing(false)
                    setCreating(false)
                }}
            >
                <Modal.Header>{creating ? 'Creando Imballo' : 'Modificando Imballo'}</Modal.Header>
                <Modal.Content>
                    <PackageEditor
                        packageId={creating ? null : editing}
                        onSave={(pack) => {
                            setEditing(false)
                            setCreating(false)
                            setPackages([])
                            setDirty(true)
                        }}
                        onCancel={() => {
                            setEditing(false)
                            setCreating(false)
                        }}
                    />
                </Modal.Content>
            </Modal>
        </>
    )
}

const mapStateToProps = (state, ownProps) => {
    let {
        getMachineList,
        deletePackage,
        login,
        search: { data: searchText },
    } = state

    return {
        getMachineList,
        deletePackage,
        login,
        searchText,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...baseViewDispatch(dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(Packages)))
